const fnGoToSearch = ({ Id }) => `research/${Id}`;

export default {
  fnGoToSearch,
};
